import "./pwc-icon.js";
import { I as v } from "../IdController-Cpj_A6H5.js";
import { P as $ } from "../pwc-interactive-element-B6286Ky3.js";
import { x as m, E as y, c as _ } from "../lit-element-8JrrHldg.js";
import { P as o } from "../pwc-component-size.enum-ldIKEMHl.js";
import { p } from "../pwcProperty-CTLG9yrF.js";
import "../chevron-down-BoZe62Bw.js";
import "../chevron-right-c8G7hZDs.js";
import { c as l } from "../clsx-DB4S2d7J.js";
import { n as h } from "../property-4FoNj0Pi.js";
import { e as w } from "../query-C42EGI_8.js";
import { s as g, u as P } from "../static-CPcCYSrK.js";
var c = /* @__PURE__ */ ((e) => (e.Default = "default", e.Raised = "raised", e.Bordered = "bordered", e))(c || {}), a = /* @__PURE__ */ ((e) => (e.Start = "start", e.End = "end", e))(a || {}), b = /* @__PURE__ */ ((e) => (e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.SPAN = "span", e.DIV = "div", e))(b || {}), S = Object.defineProperty, E = Object.getOwnPropertyDescriptor, i = (e, r, n, d) => {
  for (var s = d > 1 ? void 0 : d ? E(r, n) : r, u = e.length - 1, f; u >= 0; u--)
    (f = e[u]) && (s = (d ? f(r, n, s) : f(s)) || s);
  return d && s && S(r, n, s), s;
};
let t = class extends $ {
  constructor() {
    super(...arguments), this.getIconSize = () => {
      switch (this.size) {
        case o.Large:
          return 24;
        case o.Small:
          return 16;
        default:
          return 20;
      }
    }, this.printChevron = (e) => {
      let r = "chevron-down";
      return e === a.Start && (r = "chevron-right"), m`<pwc-icon
      icon=${r}
      size=${this.getIconSize()}
      class=${l({ "PwcExpandable__chevron-rotate": this.isOpen })}
    ></pwc-icon>`;
    }, this.onKeyDown = (e) => {
      ["Enter", "NumpadEnter", "Space"].some((n) => n === e.code) && (e.preventDefault(), this.toggleContent());
    }, this.slotControlled = ["default", "prepend"], this.idController = new v(this, {
      base: "PwcExpandable",
      children: ["header", "content"]
    });
  }
  open() {
    this.isOpen = !0, this.emit("p-opened", {});
  }
  close() {
    this.isOpen = !1, this.emit("p-closed", {});
  }
  toggleContent() {
    this.disabled || (this.isOpen ? this.close() : this.open(), this.emit("p-toggled", {}));
  }
  printPrependIcon() {
    if (this.icon !== void 0)
      return m`<pwc-icon
      icon=${this.icon}
      size=${this.getIconSize()}
    ></pwc-icon>`;
  }
  connectedCallback() {
    super.connectedCallback(), this.defaultOpen && (this.isOpen = !0);
  }
  render() {
    const e = g(this.titleTag), {
      idController: {
        child: { header: r, content: n }
      }
    } = this;
    return m`<div
      class="${l("PwcExpandable", {
      "PwcExpandable--appearance-raised": this.appearance === c.Raised,
      "PwcExpandable--appearance-bordered": this.appearance === c.Bordered,
      "PwcExpandable--size-sm": this.size === o.Small,
      "PwcExpandable--size-md": this.size === o.Medium || !Object.values(o).includes(this.size),
      "PwcExpandable--size-lg": this.size === o.Large,
      "PwcExpandable--disabled": this.disabled
    })}"
    >
      <div
        id="${r}"
        role="button"
        aria-expanded=${this.isOpen}
        aria-controls=${n}
        aria-disabled=${this.disabled ? !0 : y}
        tabindex=${this.disabled ? "-1" : "0"}
        @click=${this.toggleContent}
        @keydown=${this.onKeyDown}
        class="${l("PwcExpandable__header", {
      "PwcExpandable__header--disabled": this.disabled,
      "PwcExpandable__header--border-radius": this.isOpen
    })}"
      >
        <div class="PwcExpandable__header-left-section">
          ${this.alignChevron === a.Start ? this.printChevron(a.Start) : null}
          ${!this.slotted.prepend && this.printPrependIcon() || ""}
          <p-slot .host=${this} name="prepend"></p-slot>

          <div class="PwcExpandable__header-title-box">
            ${P`<${e}>${this.title}</${e}>`}
            <p-slot .host=${this} name="title-append"></p-slot>
          </div>
        </div>

        <div class="PwcExpandable__header-right-section">
          <p-slot .host=${this} name="append"></p-slot>
          ${this.alignChevron === a.End ? this.printChevron(a.End) : null}
        </div>
      </div>

      <div
        id="${n}"
        aria-labelledby="${r}"
        class=${l("PwcExpandable__content", {
      "PwcExpandable__content--opened": this.isOpen
    })}
      >
        <div>
          <p-slot .host=${this}></p-slot>
          ${!this.slotted.default && this.content || ""}
        </div>
      </div>
    </div>`;
  }
};
i([
  h({ type: Boolean, attribute: "is-open", reflect: !0 })
], t.prototype, "isOpen", 2);
i([
  h({ type: Boolean, attribute: "default-open" })
], t.prototype, "defaultOpen", 2);
i([
  p({ type: String, default: c.Default })
], t.prototype, "appearance", 2);
i([
  p({ type: String, default: "" })
], t.prototype, "title", 2);
i([
  h({ type: String })
], t.prototype, "content", 2);
i([
  p({
    type: String,
    attribute: "align-chevron",
    default: a.End
  })
], t.prototype, "alignChevron", 2);
i([
  p({ type: String, default: o.Medium })
], t.prototype, "size", 2);
i([
  h({ type: String })
], t.prototype, "icon", 2);
i([
  p({ type: Boolean, default: !1 })
], t.prototype, "disabled", 2);
i([
  p({
    type: String,
    attribute: "title-tag",
    default: b.H4
  })
], t.prototype, "titleTag", 2);
i([
  w(".PwcExpandable__header")
], t.prototype, "header", 2);
t = i([
  _("pwc-expandable")
], t);
export {
  t as PwcExpandable
};
